import { SeoMeta } from "@/utils/seo/SeoMeta";
import Layout from "@components/layout/Layout";
import * as P from "@components/customizing/print/Print.styles";
import { PrintDesignService } from "@components/customizing/print/PrintDesignService";
import { PrintTab } from "@components/customizing/print/printTab/PrintTab";

{
  /* 재질 */
}
const PrintMaterialsPage = () => {
  return (
    <Layout
      parent={"홈"}
      sub={"소량인쇄"}
      subTitle={"재질"}
      pageTitle={SeoMeta.smallPrintServiceMaterials.title}
      pageDesc={SeoMeta.smallPrintServiceMaterials.description}
      pageKeyword={SeoMeta.smallPrintServiceMaterials.keywords}
    >
      <PrintTab />
      <P.ProductInfoFeature className="container" id="feature">
        {/* 1 */}
        <div className="d-flex flex-column mb-50 pb-80 border-bottom">
          <div className="d-flex flex-column mb-50">
            <P.NormalTitle>
              칼렛스토어의
              <strong> 특별한 재질</strong>을 확인해 보세요.
            </P.NormalTitle>
            <P.NumberUnderBarTitle>01</P.NumberUnderBarTitle>
            <P.MediumTitle>EL606 택배봉투</P.MediumTitle>
            <P.TitleDesc>
              탄소 저감에 도움을 주는 재생비닐 친환경 택배봉투입니다.
            </P.TitleDesc>
            <P.ImgGridWrapper length={2}>
              <P.ImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL606택배봉투_1.jpg" />
                <span>
                  인장력과 사이드 실링이 튼튼하여 높은 내구성을 보입니다.
                </span>
              </P.ImgBox>
              <P.ImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL606택배봉투_2.jpg" />
                <span>
                  환경표지 인증 받은 재생플라스틱 PCR(EL606) 수지를 50% 이상
                  활용해, 탄소배출량 저감과 자원선순환에 기여합니다.
                </span>
              </P.ImgBox>
            </P.ImgGridWrapper>
          </div>
          <div className="d-flex flex-column mb-50">
            <P.NormalTitle>EL606 택배봉투 색상을 확인해 보세요.</P.NormalTitle>
            <P.SmallImgGridWrapper length={2}>
              <P.SmallImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL606택배봉투_핑크.jpg" />
                <span>인디핑크 </span>
              </P.SmallImgBox>
              <P.SmallImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL606택배봉투_네온.jpg" />
                <span>네온</span>
              </P.SmallImgBox>
            </P.SmallImgGridWrapper>
          </div>
        </div>
        {/* 2 */}
        <div className="d-flex flex-column mb-50 pb-80 border-bottom">
          <div className="d-flex flex-column mb-50">
            <P.NumberUnderBarTitle>02</P.NumberUnderBarTitle>
            <P.MediumTitle>EL727 택배봉투</P.MediumTitle>
            <P.TitleDesc>
              탄소 저감에 도움을 주는 바이오매스 택배봉투입니다.
            </P.TitleDesc>
            <P.ImgGridWrapper length={2}>
              <P.ImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727택배봉투_1.jpg" />
                <span>
                  내구성이 우수하고 이중합지로 질기고 튼튼하게 제작되었습니다.
                </span>
              </P.ImgBox>
              <P.ImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727택배봉투_2.jpg" />
                <span>
                  바이오매스 소재 인증을 받아 탄소저감에 효과가 있습니다.
                </span>
              </P.ImgBox>
            </P.ImgGridWrapper>
          </div>
          <div className="d-flex flex-column mb-50">
            <P.NormalTitle>EL727 택배봉투 색상을 확인해 보세요.</P.NormalTitle>
            <P.SmallImgGridWrapper length={2}>
              <P.SmallImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727택배봉투_크림.jpg" />
                <span>크림</span>
              </P.SmallImgBox>
              <P.SmallImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727택배봉투_블랙.jpg" />
                <span>블랙</span>
              </P.SmallImgBox>
            </P.SmallImgGridWrapper>
          </div>
        </div>
        {/* 3 */}
        <div className="d-flex flex-column mb-0 pb-80">
          <div className="d-flex flex-column mb-50">
            <P.NumberUnderBarTitle>03</P.NumberUnderBarTitle>
            <P.MediumTitle>EL727 속비닐봉투</P.MediumTitle>
            <P.TitleDesc>
              탄소 저감에 도움을 주는 친환경 바이오매스 속비닐봉투입니다.
            </P.TitleDesc>
            <P.ImgGridWrapper length={2}>
              <P.ImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727속비닐봉투_1.jpg" />
                <span>
                  내구성이 우수하고 이중합지로 질기고 튼튼하게 제작되었습니다.
                </span>
              </P.ImgBox>
              <P.ImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727속비닐봉투_2.jpg" />
                <span>
                  바이오매스 소재 인증을 받아 탄소저감에 효과가 있습니다.
                </span>
              </P.ImgBox>
            </P.ImgGridWrapper>
          </div>
          <div className="d-flex flex-column mb-50">
            <P.NormalTitle>
              EL727 속비닐봉투 색상을 확인해 보세요.
            </P.NormalTitle>
            <P.SmallImgGridWrapper length={1}>
              <P.SmallImgBox>
                <img src="/assets/imgs/print/info_feature/상품소개_재질_EL727속비닐봉투_반투명.jpg" />
                <span>반투명 </span>
              </P.SmallImgBox>
            </P.SmallImgGridWrapper>
          </div>
        </div>
      </P.ProductInfoFeature>
      <PrintDesignService />
    </Layout>
  );
};
export default PrintMaterialsPage;
